import { Box, Tab, Tabs, Typography } from "@material-ui/core";
import React, { useState, ChangeEvent } from "react";
import { ExistingPostMortemForm } from "../ExistingPostMortemForm";
import { NewPostMortemForm } from "../NewPostMortemForm";

interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

function TabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

interface Props {}

export const PostMortemTab: React.FC<Props> = (): JSX.Element => {
  const [value, setValue] = useState(0);

  const handleChange = (_event: ChangeEvent<{}>, newValue: number) => {
    setValue(newValue);
  };

  return (
    <div>
      <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
        <Tabs value={value} onChange={handleChange}>
          <Tab label="Create New Post Mortem" />
          <Tab label="Register Existing Post Mortem" />
        </Tabs>
      </Box>
      <TabPanel value={value} index={0}>
        <NewPostMortemForm />
      </TabPanel>
      <TabPanel value={value} index={1}>
        <ExistingPostMortemForm />
      </TabPanel>
    </div>
  );
};
